import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Skeleton,
  Box,
} from '@mui/material';

interface TableSkeletonProps {
  /**
   * Number of rows to display (default: 5)
   */
  rows?: number;

  /**
   * Number of columns to display (default: 6)
   */
  columns?: number;

  /**
   * Column headers to show (optional)
   */
  headers?: string[];

  /**
   * Show header skeleton (default: true)
   */
  showHeader?: boolean;
}

/**
 * Skeleton loader for tables
 * Displays animated skeleton rows while data is loading
 */
export const TableSkeleton: React.FC<TableSkeletonProps> = ({
  rows = 5,
  columns = 6,
  headers = [],
  showHeader = true,
}) => {
  return (
    <TableContainer>
      <Table>
        {showHeader && (
          <TableHead>
            <TableRow>
              {headers.length > 0
                ? headers.map((header, index) => (
                    <TableCell key={index}>
                      <Box fontWeight="bold">{header}</Box>
                    </TableCell>
                  ))
                : Array.from({ length: columns }).map((_, index) => (
                    <TableCell key={index}>
                      <Skeleton variant="text" width="80%" data-testid="table-skeleton-header-cell" />
                    </TableCell>
                  ))}
            </TableRow>
          </TableHead>
        )}
        <TableBody>
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <TableRow key={rowIndex}>
              {Array.from({ length: columns }).map((_, colIndex) => (
                <TableCell key={colIndex}>
                  {colIndex === 0 ? (
                    <Skeleton variant="text" width="60%" data-testid="table-skeleton-cell" />
                  ) : colIndex === columns - 1 ? (
                    <Skeleton variant="rounded" width={40} height={32} data-testid="table-skeleton-cell" />
                  ) : (
                    <Skeleton variant="text" width="80%" data-testid="table-skeleton-cell" />
                  )}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
